<template>
    <div class="row">
        <div class="col-12">
            <h4
                class="h4"
            >
                <b v-html="task.question" />
            </h4>
            <div>
                <b>A helyes válasz</b>
                <ul>
                    <li
                        v-for="(answer, answerIndex) in goodAnswers"
                        :key="`answer-${answerIndex}`"
                    >{{ answer.answer }}</li>
                </ul>
            </div>
            <div>
                <b>Az Ön által választott megoldás:</b>
                <ul>
                    <li>{{ userTask.solution.answers }}</li>
                </ul>
            </div>

            <div>

            </div>

        </div>
    </div>
</template>
<script>
import {filter} from "lodash";
export default {
    props: {
        userTask: {
            type: Object,
            required: true,
        },
        task: {
            type: Object,
            required: true,
        },
    },
    computed: {
        goodAnswers() {
            return filter(this.task.taskable.answers, {status: 'true'});
        }
    }
}
</script>
